import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Title from "../../../../../base/text/title/index.js";
import { genKey } from "../../../../../../helpers/keys.js";
import BlogItem from "../../components/blog-item/views/mobile/index.js";
import * as S from "./styled.js";
export const BlogMobile = ({ props  })=>{
    const { title , items =[] , config , link  } = props ?? {};
    return /*#__PURE__*/ _jsxs(S.MobileBlogFeed, {
        "data-testid": "Blog",
        ...props,
        children: [
            title && /*#__PURE__*/ _jsx(Title, {
                title: title
            }),
            /*#__PURE__*/ _jsxs(S.MobileBlogList, {
                children: [
                    items.filter((item)=>item.featured).map((item, index)=>/*#__PURE__*/ _jsx(BlogItem, {
                            config: config,
                            ...item
                        }, genKey({
                            link,
                            index
                        }))),
                    /*#__PURE__*/ _jsx(S.MobileBlogListSecondary, {
                        children: items.filter((item)=>!item.featured).map((item, index)=>/*#__PURE__*/ _jsx(BlogItem, {
                                config: config,
                                ...item
                            }, genKey({
                                link,
                                index
                            })))
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(S.MobileBlogFeedFooter, {
                children: config?.literals?.viewMore && /*#__PURE__*/ _jsx(S.MobileBlogFeedFooterLink, {
                    href: link.href,
                    title: link.title,
                    target: link.target,
                    children: config.literals.viewMore
                })
            })
        ]
    });
};
export default BlogMobile;

//# sourceMappingURL=index.js.map